<template>
  <section class="datos-reserva">
    <section class="habitaciones" v-if="multiHabitacion">
      <h5 v-text="idioma.selecciona"></h5>
      <select name="habitacion" id="habitacion" v-model="habitacion" @change="seleccionHabitacion">
        <option value="{habitacionId: -1 , habitacionNombre: 'No seleccionada'}" default selected disabled v-text="idioma.selecciona"></option>
        <option :value="{id: habitacion.id, nombre: habitacion.nombre}" :key="habitacion.id"
                v-for="(habitacion, index) in ref.habitaciones">{{habitacion.nombre}}
        </option>
      </select>
    </section>
    <section class="fechas-reserva" v-if="verFechas">
      <h5 class="position-relative d-inline-block">{{idioma.sistema}}
        <div class="infoBtn infoBtnContinuo" data-toggle="modal" data-target="#infoReserva"><i
          class="fa icon-info info"></i></div>
      </h5>
      <article class="datosReserva row">
        <div class="col-12 col-md-6 margintop20">
          <div class="infoBtn" data-toggle="modal" data-target="#infoFechas"><i class="fa icon-info info"></i></div>
          <AYRDatepickerJS :dates="ayrDates" :format="'dd-mm-yyyy'"
                         :single="false"
                         :maximo-dias="numeroDias"
                         :idioma="idiomaCalendario"
                         @checkInChanged="checkIngChange" @checkOutChanged="checkOutChange"/>

          <button id="limpiarFechas" @click="limpiarFechas"><i class="fa fa-trash"></i></button>
        </div>

        <div class="col-12 col-md-6 text-right position-relative margintop20">
          <label for="personas" v-text="idioma.numeroPlazas"></label>
          <div class="infoBtn" data-toggle="modal" data-target="#infoPlazas"><i class="fa icon-info info"></i></div>
          <select name="personas" id="personas" required v-model="personas" @change="seleccionPersonas">
            <option :key="idx" :value="opcion" v-for="(opcion,idx) in 25">{{opcion}}</option>
          </select>
        </div>

        <div class="clearfix"></div>
        <div v-if="isMultiple" class="col-12 position-relative margintop20">
          <button class="cancelar margintop20" @click="$emit('cancelBooking')">Cancelar la reserva</button>
        </div>

        <div class="form-group col-12 margintop20" v-if="errors.dates.valid && errors.persons.valid">

          <!--<label for="otro" v-if="!error.fechas && !error.plazas">-->
          <div v-if="true">
            <p><strong v-text="idioma.multiple.cabecera"></strong> {{ idioma.multiple.texto }}</p>

            <!-- 
            <div class="checkbox">
              <label class="chkReservas" v-if="getBooking().items.length < 4">
                <input type="checkbox" name="otro" id="otro" v-model="chkNuevo" style="display: inline;">
                {{idioma.otro}}
              </label>
            </div>
            -->

            <div class="vue-checkbox-wrapper" v-if="getBooking().items.length < 4" >
              <input type="checkbox" id="otro" name="otro" class="custom-checkbox" v-model="chkNuevo" >
              <label for="otro" class="custom-checkbox-label">
                <span class="custom-checkbox-text">
                  {{idioma.otro}}
                </span>
              </label>
            </div>

          </div>

          <div v-else>
            <small class="mensaje-error">
              <i class="fa fa-exclamation-triangle"></i>
              {{idioma.errorReserva}}
            </small>
          </div>

        </div>
        <div class="form-group col-12 margintop20" v-else-if="(errors.dates.errors.length > 0 || errors.persons.errors.length > 0)">
          <ul>
            <li v-for="(texto, idx) in showErrors">
              {{texto}}
            </li>
          </ul>
        </div>

        <!-- alvaro + chatGPT 
        <div class="vue-checkbox-wrapper">
          <input type="checkbox" id="customCheckbox" name="customCheckbox" class="custom-checkbox">
          <label for="customCheckbox" class="custom-checkbox-label">
            <span class="custom-checkbox-text">
              prueba + chatGPT 2
            </span>
          </label>
        </div>
        -->
      </article>
      <!-- Paso 2.1: Dar la opción de añadir otro refugio a la reserva o finalizar la reserva -> 3 -->
      <article class="multiple" v-if="(chkNuevo && allRef.length > 0)">
        <label for="nuevo" v-text="idioma.seleccionaOtro"></label>
        <select name="nuevo" id="nuevo" v-model="selectNuevo">
          <option value="0" selected disabled>{{idioma.seleccionaOtro}}</option>
          <option :value="nuevoRef.id" :key="idx" v-for="(nuevoRef,idx) in otrosRefugios">{{nuevoRef.nombre}}</option>
        </select>
        <button @click="addRefugio" type="button" v-text="idioma.otroBtn"></button>
      </article>

      <article class="hacia-servicios" v-if="errors.dates.valid && errors.persons.valid">
        <button @click="seleccionarServicios" type="button" v-text="idioma.continuar"></button>
      </article>
    </section>
    <ModalsController :idioma="idioma" modal="infoReserva"></ModalsController>
    <ModalsController :idioma="idioma" modal="infoFechas"></ModalsController>
    <ModalsController :idioma="idioma" modal="infoPlazas"></ModalsController>
  </section>
</template>

<script>
  import {mapGetters, mapMutations, mapActions} from 'vuex'
  import {refugeService} from '../../_services'
  import {refugesHelper, datesHelper} from '../../_helpers'
  import AYRDatepicker from './AYRDatepicker'
  import ModalsController from "../modals/ModalsController";
  import AYRDatepickerJS from './AYRDatepickerJS.vue';

  export default {
    name: "booking-container",
    props: ['refugio', 'idioma', 'idiomaCalendario', 'otros'],
    data() {
      return {
        ref: {},
        chkNuevo: false,
        selectNuevo: 0,
        allRef: [],
        multiHabitacion: false,
        verFechas: false,
        checkInStatus: false,
        checkOutStatus: false,
        rangeDatesStatus: false,
        habitacion: {
          id:0,
          nombre:''
        },
        personas:1,
        personasOk: false,
        errors:{
          dates:{
            valid: false,
            errors: []
          },
          persons:{
            valid: false,
            errors:[]
          }
        },
        ayrDates: {
          0: [],
          1: [],
          2: [],
          3: [],
          4: [],
          5: [],
          6: []
        },
        insResult:{},
        verServicios: false,
        isMultiple: false,
        numeroDias: 5,
      }
    },
    created() {
      // Limpiar datos del refugio anterior o inicializar uno nuevo
      this.ref = refugesHelper.cleanApiData(this.refugio)
      this.clearRefugeData()

      if(this.otros) this.allRef = this.otros

      this.setCurrentRefuge( {id:this.ref.id, name:this.ref.nombre, covidAlert:this.refugio.covidAlert} )
      if(this.ref.habitaciones.length > 1) {
        this.multiHabitacion = true
      }
      else{
        this.habitacion.id = this.ref.habitaciones[0].idHabitacion
        this.habitacion.nombre = this.ref.habitaciones[0].nombre
        this.seleccionHabitacion()
      }

    },
    watch: {
      chkNuevo: {
        handler(nuevo) {
          if (this.allRef.length == 0 && nuevo)
            refugeService.getAll().then(data => {
              // Muestra solo los refugios que no estan en la reserva o que esta seleccionado
              this.allRef = data.filter((r) => {
                const _cBooking = this.getBooking()
                let result = true
                if(_cBooking.items.length > 0){
                  _cBooking.items.forEach((_cRef)=> {
                    if(parseInt(_cRef.id) === parseInt(r.id)) result = false
                  })
                }
                if(result) return r
              })
            })
        }
      }
    },
    computed:{
      otrosRefugios() {
        return this.allRef.filter(( r ) => this.ref.id !== r.id )
      },
      showErrors(){
        return this.errors.dates.errors.concat(this.errors.persons.errors)
      }
    },
    methods: {
      ...mapGetters(['getRefuge','getBooking']),
      ...mapActions(['changeCheckIn', 'changeCheckOut']),
      ...mapMutations(['setCurrentRefuge', 'setCurrentRoom', 'appendRefuge', 'clearRefugeData', 'clearDates', 'setBookingData']),
      seleccionHabitacion() {
        this.$store.commit('setCurrentRoom', { id : this.habitacion.id, roomName: this.habitacion.nombre })
        if (parseInt(this.habitacion.id) === 41)
          this.numeroDias = 3
        else
          this.numeroDias = 5
        this.cerrarFechas()
      },
      cerrarFechas(){
        this.verFechas = false
        // Limpiar estado de fechas
        this.ayrDates[0] = []
        this.ayrDates[1] = [] //Dispnible
        this.ayrDates[2] = [] //Completo
        this.ayrDates[3] = [] //Cerrado
        this.ayrDates[4] = [] //Sin plazas para reserva online
        this.ayrDates[5] = [] //Fecha seleccionada en otro refugio.
        this.ayrDates[6] = [] //Deshabilitado
        
        // Establecer fechas del refugio seleccionado
        let _habitacion = this.ref.habitaciones.filter((h) => h.idHabitacion == this.habitacion.id)[0]
        _habitacion.plazas.forEach(plaza => {
          let _fecha = datesHelper.dateToMoment((plaza.fechaUTC*1000))
          if(plaza.estado){ 
            //Comprobar que hay plazas para reservar online
            if(plaza.plazas >= 1)
              this.ayrDates[plaza.estado.toString()].push(_fecha.format('x'))
            else {
              if ( plaza.estado === 2 || plaza.estado === 3 ) { //Si esta completo o cerrado
               this.ayrDates[plaza.estado.toString()].push(_fecha.format('x'))
              } else { //Si no tiene plazas y no está completo
                this.ayrDates['4'].push(_fecha.format('x'))
              }
              //Antes si no tenia plazas online, se añadia como "Sin plazas online" independientemente si estaba completo o cerrado
              //this.ayrDates['4'].push(_fecha.format('x'))
            }
          }
          else this.ayrDates['5'].push(_fecha.format('x'))
        })

        // Si es multiple cerrar las fechas de los refugios anteriores
        const currentBooking = this.getBooking()
        if(currentBooking.items.length > 0){
          currentBooking.items.forEach((ref) => {
            this.ayrDates['5'].push(ref.checkIn.format('x'))
            //this.ayrDates['5'].push(ref.checkOut)
            datesHelper.daysBetween(ref.checkIn, ref.checkOut).forEach((_d) => this.ayrDates['5'].push(_d.format('x')))
          })
        }
        this.verFechas = true
      },
      checkIngChange(_date){
        // Dia seleccionado
        let _d = datesHelper.momentToDate(_date,'x')
        // Dia actual
        let currentDate = new Date();
        //Desglose por partes de la fecha actual
        let currentDay = currentDate.getDate();
        let currentMonth = currentDate.getMonth();
        let currentYear = currentDate.getFullYear();

        let currentFullDate = currentYear+'-'+currentMonth+'-'+currentDay;

        let selectedDate = new Date(_date);

        let selectedDay = selectedDate.getDate();
        let selectedMonth = selectedDate.getMonth();
        let selectedYear = selectedDate.getFullYear();

        let selectedFullDate = selectedYear+"-"+selectedMonth+"-"+selectedDay;

        let tomorrowDate = this.addFechas(currentDate, 1);

        let tomorrowDay = tomorrowDate.getDate();
        let tomorrowMonth = tomorrowDate.getMonth();
        let tomorrowYear = tomorrowDate.getFullYear();

        let tomorrowFullDate = tomorrowYear+"-"+tomorrowMonth+"-"+tomorrowDay;

        let isInvalidDate = ( currentFullDate == selectedFullDate || selectedFullDate == tomorrowFullDate );

       if (!isInvalidDate) {          
        if(this.ayrDates[1].includes(_d)){
          if(this.checkOutStatus){
            if( this._validateDatesBetween( _date.clone(), this.getRefuge().checkOut.clone() ) ){
              if(this.changeCheckOut(_date)) {
                this.checkOutStatus = true
                this.errors.dates.valid = true
                this.errors.dates.errors = []
              }
            }
          }
          else{
            if(this.changeCheckIn(_date)){
              this.checkInStatus = true
              this.errors.dates.valid = true
              this.errors.dates.errors = []
            }
          }

        }else{
          if(this.ayrDates[2].includes(_d)) {
            this.errors.dates.errors.push(this.idioma.errors.cerrado)
          }
          if(this.ayrDates[3].includes(_d)){
            this.errors.dates.errors.push(this.idioma.errors.completo)
          }
          if(this.ayrDates[4].includes(_d)){
            this.errors.dates.errors.push(this.idioma.errors.online)
          }
          this.errors.dates.valid = false
          this.checkInStatus = false
        }
      } else {
        // Las fechas no son válidas porque son hoy 0 mañana.
        this.errors.dates.valid = false;
        this.checkInStatus = false;
        this.errors.dates.errors.push(this.idioma.errors.invalidDate);
      }
        setTimeout(this.seleccionPersonas, 50)

      },
      checkOutChange(_date){
        let _d = _date.format('x')
        if(this.ayrDates[2].includes(_d)){
          this.errors.dates.errors.push(this.idioma.errors.salida)
          this.checkOutStatus = false
          this.errors.dates.valid = false
        }else if(this.checkInStatus){
          // Comprobar las fechas entre checking y checkout
          if( this._validateDatesBetween( this.getRefuge().checkIn.clone(), _date.clone() )){
            this.changeCheckOut(_date)
            this.checkOutStatus = true
            this.errors.dates.valid = true
            this.errors.dates.errors = []
          }
        }
        this.seleccionPersonas()
      },
      _validateDatesBetween(_in, _out){
        let result = true
        const _dates = datesHelper.daysBetween(_in, _out)
        _dates.forEach((_day) => {
          let _d = _day.format('x')
          if(this.ayrDates[2].includes(_d) ||
            this.ayrDates[3].includes(_d) ||
            this.ayrDates[4].includes(_d) ||
            this.ayrDates[5].includes(_d)){
            this.errors.dates.valid = false
            this.errors.dates.errors.push(`${_day.format('DD-MM-YYYY')}: ${this.idioma.errors.rango}`)
            result = false
          }
        })
        return result
      },
      seleccionPersonas(){
        this.errors.persons.errors = []
        //Obtener los días para los que son necesario calcular la plazas
        const _d = [
          this.getRefuge().checkIn,
          ...datesHelper.daysBetween(this.getRefuge().checkIn, this.getRefuge().checkOut)
        ]
        // Habitacion escogida
        let _ch = this.ref.habitaciones.filter((h) => h.id === this.habitacion.id )[0]

        _d.forEach((_dia) => {
          let _max = _ch.plazas.filter((_p) => _p.fecha === _dia.format('YYYY-MM-DD'))[0]
          if( parseInt(this.personas) > _max.plazas) {
            const _m = `${this.idioma.errors.personas.principio}${this.personas}${this.idioma.errors.personas.final}${_dia.format('DD/MM/YYYY')}`
            this.errors.persons.errors.push(_m)
            this.errors.persons.valid = false
            this.personasOk = false
          }
          if(this.errors.persons.errors.length == 0){
            this.errors.persons.valid = true
            this.personasOk = true
          }
        })

        this.$store.commit('setCurrentPersons', this.personas)

      },
      seleccionarServicios(){
        if(this.checkInStatus && this.checkOutStatus && this.personasOk)
          this._insertRef().then((insResult) => {
            if(insResult.response){
              // Insertar refugio en la reserva y cargar los datos del nuevo refugio
              this.setBookingData({
                id:insResult.result.id,
                booking: insResult.result.reserva,
                services: insResult.result.servicios,
                otherServices: insResult.result.otrosServicios
              })
              this.appendRefuge({refuge:this.getRefuge(), msgServicios: insResult.result.msgServicios})
              //Hacia los servicios
              this.$emit('seleccionServicios')
            }else{
              // Mostrar el mensaje del error
              this.$emit('errorHandler', { errorMessage: insResult.message})
            }
          })
        else
          console.log("NO PASA!!!")
      },
      addRefugio() {
        //Agregar refugio a la reserva
        if (this.selectNuevo) {

          this._insertRef().then((insResult) => {
            if(insResult.response){
              // Insertar refugio en la reserva y cargar los datos del nuevo refugio
              this.setBookingData({
                id:insResult.result.id,
                booking: insResult.result.reserva,
                services: insResult.result.servicios,
                otherServices: insResult.result.otrosServicios,
                msgServicios: insResult.result.msgServicios
              })
              this.appendRefuge({refuge:this.getRefuge(), msgServicios: insResult.result.msgServicios})
              this.isMultiple = true
              this.$emit('nuevoRefugio', this.selectNuevo)
            }else{
              this.$emit('errorHandler', { errorMessage: insResult.message})
            }
          })
        }
      },
      _insertRef(){

        const _current = this.getRefuge()
        const _send = {
          idRefugio: _current.id,
          idHabitacion: _current.idRoom,
          nombre: _current.name,
          checkIN: _current.checkIn.format('Y-MM-DD'),
          checkOUT: _current.checkOut.format('Y-MM-DD'),
          noches: _current.nigths,
          personas: _current.persons
        }
        return  refugeService.postRefuge(refugesHelper.prepareToSend(_send))
      },
      limpiarFechas(){
        this.verFechas = false
        this.checkInStatus = false
        this.checkOutStatus = false
        this.clearDates()
        setTimeout(() => this.verFechas = true, 10)
      },
      addFechas ( _date, days ) {
        let newDate = new Date();
        let currentDate = _date.setDate(_date.getDate() + days );
        return new Date(currentDate);
      }
    },
    components: {
      ModalsController,
      AYRDatepickerJS,

    }
  }
</script>




// WEBPACK FOOTER //
// src/components/booking/BookingContainer.vue